import { getCookieDomain } from '@white-label-helper/get-cookie-domain';
import { CACHE_KEY_PREFIX, COOKIES_KEY_PREFIX } from '../../constants';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';
import { isMultiChannelPartnerEnabled } from '@white-label-helper/dedicated-flow';

export const setUserTokenWrapper = (
    token: string,
    tokenExpiration: number,
    channelToken: string,
    // channelToken is multichannel dependent and moves away from auth0 users token.
    app: Context['app'],
    authInstance: AuthObject
) => {
  const tokenStorageKey = `${CACHE_KEY_PREFIX}::${authInstance.clientId}::${authInstance.audience}::openid profile email`;
  const tokenNoBearer = token.replace('Bearer ', '');

  const tokenData = {
    body: {
      access_token: tokenNoBearer,
      audience: authInstance.audience,
      client_id: authInstance.clientId,
      oauthTokenScope: "openid profile email",
      scope: "openid profile email",
      token_type: "Bearer"
    },
    expiresAt: tokenExpiration,
  }

  const cookieDomain = getCookieDomain();

  app['$cookies'].set(`_legacy_${COOKIES_KEY_PREFIX}.${authInstance.clientId}.is.authenticated`, true, {
    domain: cookieDomain,
    secure: true,
    maxAge: tokenExpiration - new Date().getTime() / 1000,
    path: '/'
  });
  app['$cookies'].set(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.is.authenticated`, true, {
    domain: cookieDomain,
    sameSite: 'None', secure: true,
    maxAge: tokenExpiration - new Date().getTime() / 1000,
    path: '/'
  });
  app['$cookies'].set(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.token`, token, {
    domain: cookieDomain,
    path: '/',
    secure: true,
    sameSite: 'Strict',
  });
  app['$cookies'].set(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.tokenExpiration`, tokenExpiration, {
    domain: cookieDomain,
    path: '/'
  });
  app['$cookies'].set(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.returnUrl`, authInstance.returnUrl, {
    domain: cookieDomain,
    path: '/',
  });
  if (channelToken && isMultiChannelPartnerEnabled()) {
    app['$cookies'].set(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.channelToken`, channelToken, {
      domain: cookieDomain,
      path: '/',
      maxAge: tokenExpiration - new Date().getTime() / 1000,
    });
  }

  localStorage.setItem(tokenStorageKey, JSON.stringify(tokenData));
}
